/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Production only: caches the app shell (JS/CSS/HTML + the SQLite WASM
// engine) so the app boots with no network at all. The service worker is
// configured with skipWaiting, so a deployed update is picked up on the next
// page load — never by force-reloading a page mid-game.
if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker.')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; it will be used on next reload.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
